import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getUserProgressData, getUserProgressDetailsData } from "@/api/course";
import { mixin_export } from '@/utils/exportFile';
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.search = {
            courseId: '',
            userId: '',
            title: ''
        };
        this.courseType = '1';
        this.form = {
            taskCompleteNum: '',
            examCompleteNum: '',
            examSumScore: '',
            spendTotalTimeStr: '',
            learnSumProgressStr: '',
            userId: '',
            nickName: '',
            joinTime: '',
            completionRateStr: ''
        };
        this.tableData = [];
        this.pageNo = 1;
        this.pageSize = 15;
        this.total = 0;
    }
    created() {
        if (this.$route.query.courseId) {
            this.search.courseId = this.$route.query.courseId;
            this.search.userId = this.$route.query.userId;
            this.courseType = this.$route.query.courseType;
            this.getData();
            this.getList();
        }
    }
    async getData() {
        const res = await getUserProgressData(this.search);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.form.taskCompleteNum = res.data.data.taskCompleteNum;
        this.form.examCompleteNum = res.data.data.examCompleteNum;
        this.form.examSumScore = res.data.data.examSumScore;
        this.form.spendTotalTimeStr = res.data.data.spendTotalTimeStr;
        this.form.learnSumProgressStr = res.data.data.learnSumProgressStr;
        this.form.userId = res.data.data.userId;
        this.form.nickName = res.data.data.nickName;
        this.form.joinTime = res.data.data.joinTime;
        this.form.completionRateStr = res.data.data.completionRateStr;
    }
    onSearch() {
        this.pageNo = 1;
        this.getList();
    }
    async getList() {
        let data = {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            courseId: this.search.courseId,
            userId: this.search.userId,
            title: encodeURIComponent(this.search.title)
        };
        const res = await getUserProgressDetailsData(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.tableData = res.data.data.list || [];
        this.pageNo = Number(res.data.data.pageNum);
        this.total = Number(res.data.data.total);
    }
    onExport() {
        this.$confirm('是否确认导出？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let data = {
                courseId: this.search.courseId,
                userId: this.search.userId,
                title: encodeURIComponent(this.search.title)
            };
            mixin_export('/courseAdmin/userProgress/exportSingleUserProgressDetail', 'get', data);
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
    changePage(pageNo) {
        this.pageNo = pageNo;
        this.getList();
    }
    changePageSize(pageSize) {
        this.pageSize = pageSize;
        this.getList();
    }
};
Login = tslib_1.__decorate([
    Component
], Login);
export default Login;
